import { __rest } from "tslib";
import * as React from 'react';
import { Input, Typography } from 'antd';
const { Text } = Typography;
const AntdInput = (_a) => {
    var { input, meta, label } = _a, rest = __rest(_a, ["input", "meta", "label"]);
    const isError = meta.error && meta.touched;
    return (React.createElement("div", null,
        React.createElement("label", null, label),
        React.createElement(Input, Object.assign({}, input, rest)),
        meta.error && meta.touched && React.createElement(Text, { type: 'danger' }, meta.error)));
};
export default AntdInput;
export { AntdInput };
//# sourceMappingURL=index.js.map